module.exports = __webpack_public_path__ + "7d8d12313d8e1b1228952f4e48e5a983.fbx";